export default __webpack_public_path__ + "static/media/20.656d4a7f.jpg";